import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { LuAttendanceKPI } from "src/app/models/HR/AttendanceKPI/attendanceKPI.model";
import { IAttendanceKPIRepository } from "./IAttendanceKPIRepository";

@Injectable()
export class AttendanceKPIRepository extends GenericRepository<LuAttendanceKPI> implements IAttendanceKPIRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/luAttendanceKPI', environment.urlAddress);
    }
    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: LuAttendanceKPI): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(Id: number): Observable<ResponseModel> {
        return this.GetById('/GetRec/' + Id).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(Id: number): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + Id).pipe(map(this.extractData), catchError(this.handleError));
    }
}